import React from "react";
import appleIcon from "../assets/appleIcon.png";
import googlePlayIcon from "../assets/googlePlayIcon.png";
import homeHome from "../assets/home-home.png";
import statsHome from "../assets/stats-home.png";

const Introduction = () => {
  return (
    <section className="introduction">
      <div className="introduction-content">
        <div className="early-access">
          <div className="early-access-circle"></div>
          Now in Early Access
        </div>
        <h2 className="introduction-title">
          <span>Stop planning.</span>
          <span className="highlight">Start executing.</span>
        </h2>
        <p className="introduction-text">
          vectr42 is the AI-powered strategic execution platform that turns your
          goals into actionable intelligence - giving leaders clarity and
          momentum.
        </p>
        <div className="app-buttons">
          <a href="https://apps.apple.com/us/app/vectr42/id6775978008" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
            <button className="app-store-btn">
              <img src={appleIcon} alt="Apple" className="store-icon-img" />
              <div className="store-btn-text">
                <div className="store-label">Download on the</div>
                <div className="store-name">App Store</div>
              </div>
            </button>
          </a>
          <button className="play-store-btn">
            <img
              src={googlePlayIcon}
              alt="Google Play"
              className="store-icon-img"
            />
            <div className="store-btn-text">
              <div className="store-label">Get it on</div>
              <div className="store-name">Google Play</div>
            </div>
          </button>
        </div>
      </div>
      <div className="introduction-images">
        <div className="intro-images-wrapper">
          <img src={homeHome} alt="vectr42 home" className="intro-home-img" />
          <img src={statsHome} alt="vectr42 stats" className="intro-stats-img" />
        </div>
      </div>
    </section>
  );
};

export default Introduction;
